// extracted by mini-css-extract-plugin
module.exports = {"block":"Artisan_block__yGMna","list":"Artisan_list__2mqMi"};